import React from "react";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";

export default function ThankYou() {
    return (
        <section
            data-testid="thank-you-section"
            className="relative min-h-[70vh] flex items-center py-24"
        >
            <div className="mx-auto max-w-3xl px-6 text-center">
                <div className="inline-flex h-16 w-16 items-center justify-center rounded-full bg-brand-primary/10 text-brand-primary mx-auto mb-8">
                    <Check size={28} />
                </div>
                <div className="text-xs uppercase tracking-[0.24em] text-brand-accent font-semibold mb-4">
                    Received
                </div>
                <h1
                    data-testid="thank-you-title"
                    className="font-serif-editorial text-5xl md:text-6xl tracking-tight text-brand-primary leading-[1.04]"
                >
                    Thank you — we're
                    <br />
                    <em className="italic font-light text-brand-accent">on it.</em>
                </h1>
                <p className="mt-6 text-lg text-brand-muted leading-relaxed">
                    An adviser will review your message and be in touch. We take the
                    time to understand your circumstances before offering any
                    recommendations — so please allow a little time for a considered
                    response.
                </p>

                <div className="mt-10 flex items-center justify-center gap-4">
                    <Link
                        to="/"
                        data-testid="thank-you-home"
                        className="border border-brand-primary text-brand-primary px-6 py-3 text-sm hover:bg-brand-primary hover:text-brand-bg transition-colors"
                    >
                        Back to home
                    </Link>
                    <Link
                        to="/services"
                        data-testid="thank-you-services"
                        className="bg-brand-primary text-brand-bg px-6 py-3 text-sm hover:bg-brand-primaryHover transition-colors"
                    >
                        Explore services
                    </Link>
                </div>
            </div>
        </section>
    );
}
